import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/core/services/auth.service';
import { apiParameters } from 'src/app/configs/api.params';

@Component({
  selector: 'app-social-connections',
  templateUrl: './social-connections.component.html',
  styleUrls: ['./social-connections.component.css'],
})
export class SocialConnectionsComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {}

  oauthTokens: any[] = []; 
  isLoading: boolean = false;
  error: string = '';
  token: any;
  tokenDelete: any;

  instagramAuthUrl = `https://www.instagram.com/oauth/authorize?enable_fb_login=0&force_authentication=1&client_id=965047488696164&redirect_uri=${apiParameters.instagramRedirectUri}&response_type=code&scope=instagram_business_basic%2Cinstagram_business_content_publish`;
  
  ngOnInit(): void {
    this.fetchTokens();
  }

  fetchTokens(): void {
    this.isLoading = true;
    this.authService.getOauthTokens().subscribe(
      (tokens) => {
        this.oauthTokens = tokens;
        this.isLoading = false;
      },
      (error) => {
        this.error = 'Failed to load tokens';
        this.isLoading = false;
      }
    );
  }

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  showDialogDeleteToken(content, token) {
    this.token = token;
    this.tokenDelete = this.modalService.open(content, this.dialogOptions);
    this.tokenDelete.result.then(
      (result) => {},
      (reason) => {}
    );
  }

  deleteToken(tokenId: string): void {
    this.authService.deleteOauthToken(tokenId).subscribe(
      () => {
        this.oauthTokens = this.oauthTokens.filter(
          (token) => token.id !== tokenId
        );
        this.toastr.success('Token deleted successfully');
        this.tokenDelete.close();
      },
      (error) => {
        this.toastr.error('Failed to delete token');
      }
    );
  }
}
